export enum MenuTabValueEnum {
  Menu = "MENU",
  Search = "SEARCH",
  Drawing = "DRAWING",
  Move = "MOVE"
}
